module.exports = {
  author: "Shubham Singh",
  siteTitle: "Shubham Portfolio",
  siteShortTitle: "Shubham", // Used as logo text in header, footer, and splash screen
  siteDescription:
    "FullStack Developer, Lifelong learner,Enjoy using React,Typescript Next.js, Node, GraphQL, Apollo, Prisma, Styled Components, and TailwindCSS,",
  siteUrl: "https://shubhski.dev/",
  siteLanguage: "en_US",
  siteIcon: "src/content/favicon.png", // Relative to gatsby-config file

  splashScreen: false, // Set this to true if you want to use the splash screen

  // You can create your own Medium feed with this rss to json converter: https://rss2json.com/
  // To access your Medium RSS feed, just replace this url with your username: https://medium.com/feed/@{yourname}
  mediumRssFeed:
    "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2F%40shubhski",
  shownArticles: 3,

  // There are icons available for the following platforms:
  // Medium, GitHub, LinkedIn, XING, Behance
  socialMedia: [
    {
      name: "Linkedin",
      url: "https://www.linkedin.com/in/shubhski/",
    },
    {
      name: "Twitter",
      url: "https://twitter.com/shubhski",
    },
    {
      name: "Github",
      url: "https://github.com/shubhsk88",
    },
  ],

  navLinks: {
    menu: [
      {
        name: "About ",
        url: "/#about",
      },
      {
        name: "Projects",
        url: "/#projects",
      },
      {
        name: "Blog",
        url: "/#articles",
      },
    ],
    button: {
      name: "Contact",
      url: "/#contact",
    },
  },
}
